import App from '../App';
import { Route, Navigate } from "react-router-dom";
import DemoPage1 from './DemoPage1';
import Changelog from './Changelog';
import Insights from './Insights';
import About from './About';
import Contact from './Contact';
import Experimental from './Experimental';

export const routes = (finalIsDarkMode) => (
  <>
    <Route path="/" element={<App {...{ finalIsDarkMode }} />} />

    <Route path="insights" element={<Insights {...{ finalIsDarkMode }} />} />
    <Route path="changelog" element={<Changelog {...{ finalIsDarkMode }} />} />
    <Route path="about" element={<About {...{ finalIsDarkMode }} />} />
    <Route path="contact" element={<Contact {...{ finalIsDarkMode }} />} />
    <Route path="experimental" element={<Experimental {...{ finalIsDarkMode }} />} />

    <Route path="demoPage1" element={<DemoPage1 />} />

    <Route path="*" element={<Navigate to="/" replace />} />

  </>
);